import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
      refresh:false,
      storeName:'',
      dicChange:false,
     booksinfo:{
        askId: '',
        customName: '',//客户姓名
        phone: '',//手机号码
        orderDate: null,//预订日期
        activityBeginTime: '',//时间段
        activityEndTime: '',
        houseInfo: null,//预订场地info
        orderTypeId: '',//预订类型 ?orderTypeId
        //收费方式
        mainPayTypeText: '',
        mainPayType: '01',
        payTypes: [],

        packages: {},//预订套餐
        orderPackage: {},

        //增加项目
        orderExtra: {},
        extraRealMoney: 0,
        packageRealMoney: '',//套餐实收款
        packageNeedMoney: '',//套餐应收款
        orderMoney: '',//订单金额（总计应收款）
        downPayment: '',//已收定金
        alertDate: null,//提醒日期
        //总计应收
        orderState: '02',//预订状态
        customFromId: '',//顾客来源
        remark: '',//备注
    }
  },
  mutations: {

  },
  actions: {

  },
  modules: {
  },
});
